// extracted by mini-css-extract-plugin
export default {"active":"News_active__b55hk"};